import { useMeetingEventDetailQuery } from "../hooks";
import { MeetingEvent } from "../models";
import MeetingEventDetails from "./MeetingEventDetails";

interface MeetingEventPreviewProps {
  meetingEvent: MeetingEvent;
  showHeader?: boolean;
}

export default function MeetingEventPreview({
  meetingEvent,
  showHeader = true,
}: MeetingEventPreviewProps) {
  const { data, isPending } = useMeetingEventDetailQuery(meetingEvent.id);
  return (
    <MeetingEventDetails
      meetingEvent={data || meetingEvent}
      showHeader={showHeader}
      isLoading={isPending}
    />
  );
}
